export default __webpack_public_path__ + "static/media/3867.57d514d2.png";